<template>
  <div class="match-list-item" @click="matchClick(item.id, item.programId)">
    <!-- 内容 -->
    <div class="match-warp">
      <div class="left">
        <img class="logo" :src="item.logo" />
      </div>
      <div class="right">
        <div class="title">{{ item.title }}</div>
        <div class="down">
          <div class="middle">
            <div class="date-img">
              <a-icon type="clock-circle" /><span class="txt"
                >{{ (item.beginTime || '').slice(0, 10) }} ~ {{ (item.endTime || '').slice(0, 10) }}</span
              >
            </div>
            <div class="date-img">
              <a-icon type="environment" /><span class="txt">{{ item.address }}</span>
            </div>
          </div>
          <!-- 报名状态 -->
          <div class="right">
            <span class="bell"
              ><a-icon type="bell" v-if="item.levelName" /><span class="txt">{{ item.levelName }}</span></span
            >
            <div class="btn" :style="handleStatusStyle(item, 1)">
              {{ matchFun.statusText(item.status) }}
              <div class="arrows" :style="handleStatusStyle(item, 0)"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="empty"></div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import matchFun from '@comm/utils/matchFun'
export default {
  //programType:1,默认官网2.九龙坡区运会
  props: {
    item: Object,
    default: () => {
      {
      }
    },
    programType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      matchFun,
    }
  },
  methods: {
    handleStatusStyle(item, index) {
      if (index == 0) {
        return {
          'border-top-color': matchFun.statusArrowsColor(item.status),
          'border-left-color': matchFun.statusArrowsColor(item.status),
        }
      } else {
        return { 'background-color': matchFun.statusColor(item.status) }
      }
    },
    matchClick(id, programId) {
      switch (this.programType) {
        case 1:
          if (this.item.chargeMode) {
            store.commit('match/MATCH_CHANGE_ACTIVE_MENU', 2)
            this.$router.push({ name: 'ActivitySign', query: { id: id, programId: programId } })
          } else {
            store.commit('match/MATCH_CHANGE_ACTIVE_MENU', 1)
            this.$router.push({ name: 'MatchDetail', query: { matchId: id, programId: programId } })
          }
          break
        case 2:
          switch (programId) {
            case 5:
              this.$router.push({ name: 'BasketBall', query: { matchId: id, programId: programId } })
              break
            case 14:
              this.$router.push({ name: 'VolleyBall', query: { matchId: id, programId: programId } })
              break
            default:
              this.$router.push({ name: 'MatchDetail', query: { matchId: id, programId: programId } })
          }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.match-list-item {
  margin-top: 15px;
  margin-bottom: 20px;
  .match-warp {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;
    width: 590px;
    height: 100%;
    .left {
      width: 120px;
      height: 100%;
      line-height: 120px;
      text-align: center;
      background-color: #ffffff;
      .logo {
        width: 80px;
        height: 80px;
        border-radius: 40px;
      }
    }
    .right {
      width: 460px;
      height: 100%;
      background-color: #ffffff;
      box-sizing: border-box;
      .title {
        font-size: 18px;
        font-weight: bold;
        overflow: hidden;
        width: 460px;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 30px;
        margin-top: 10px;
      }
      .down {
        display: flex;
        box-sizing: border-box;
        height: 80px;
        .middle {
          width: 340px;
          height: 100%;
          .date-img {
            margin-top: 5px;
            color: #999999;
            .txt {
              display: inline-block;
              margin-left: 10px;
            }
          }
        }
        .right {
          width: 120px;
          height: 100%;
          position: relative;
          .bell {
            display: inline-block;
            text-align: center;
            margin-top: 5px;
            height: 30px;
            width: 100%;
            .txt {
              display: inline-block;
              margin-left: 5px;
            }
          }
          .btn {
            position: relative;
            width: 100px;
            color: #fff;
            text-align: center;
            line-height: 35px;
            border-radius: 5px 0 0 5px;
            margin-left: 30px;
            margin-bottom: 10px;
            .arrows {
              position: absolute;
              right: 0;
              border: 5px solid #fff;
              border-bottom-color: transparent;
              border-right-color: transparent;
            }
          }
          .btn:hover {
            color: #eee;
            font-size: 16px;
          }
        }
      }
    }
    .empty {
      width: 10px;
      height: 120px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/MatchList.vue